import { get, post } from "shared/data";
import { setSourcePage } from "components/attributes/lib/attribute-data";

export const getAggregatedProductInfo = (shipmentProductKey) => {
    return get(`/shipment-product-aggregated-information/${shipmentProductKey}`);
};

export const redoTask = (taskName, taskId, sourcePage, requestOriginTaskType) => {
    const sourcePageParam = setSourcePage(sourcePage, true);
    const requestOriginParam = requestOriginTaskType ? `&requestOriginTaskType=${requestOriginTaskType}` : "";

    return post(`/receiving/final/${taskId}/re-${taskName}${sourcePageParam}${requestOriginParam}`);
};
